module.exports = __webpack_public_path__ + "static/media/Fig-6-10.d71151e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/media/Fig-6-10.png
// module id = 784
// module chunks = 0